import { baseApi } from "../../redux/baseAPI";

export const advanceDirectiveApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDirectives: builder.query({
      query: (data) => {
        return {
          url: `/dynamic_alert/code_status_list.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: (result) =>
        result.data
        ? [
          ...result.data.map(({ id }) => ({ type: "Directive", id })),
          { type: "Directive", id: "LIST" },
        ]
        : [{ type: "Directive", id: "LIST" }],
    }),
    getCodeStatus: builder.query({
      query: (body) => {
        return {
          url: `/dynamic_alert/code_status_settings.json`,
          method: "GET",
          params: body
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    saveDirective: builder.mutation({
      query: (body) => {
        return {
          url: `/dynamic_alert/add_code_status.json`,
          method: "POST",
          data: body,
          params: body,
        }
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: [{ type: "Directive" }],
    }),
    deleteCodeStatus: builder.mutation({
      query: (body) => {
        return {
          url: `/dynamic_alert/delete_code_status.json`,
          method: "GET",
          params: body
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: [{ type: "Directive" }],
    }),
    getAdvanceDirectiveHistory: builder.query({
      query: (body) => {
        return {
          url: `/dynamic_alert/get_code_status_history.json`,
          method: "GET",
          params: body
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});


export const { useGetDirectivesQuery, useGetCodeStatusQuery, useSaveDirectiveMutation, useDeleteCodeStatusMutation, useGetAdvanceDirectiveHistoryQuery } = advanceDirectiveApi;
